import { useFeatureFlagStore } from "./useFeatureFlags";
import type { SessionInitializationStage } from "./sessionInitializationFailure";

export const sessionTestControlsEnabled =
  import.meta.env.DEV ||
  import.meta.env.VITE_ENV === "development" ||
  import.meta.env.VITE_ENV === "staging";

export type SessionTestFailure = SessionInitializationStage | "none";
const storageKey = "sellar.session-test-failure";

export const getSessionTestFailure = (): SessionTestFailure => {
  if (
    !sessionTestControlsEnabled ||
    !useFeatureFlagStore.getState().isActive("SESSION_TESTING")
  )
    return "none";
  let value: string | null;
  try {
    value = sessionStorage.getItem(storageKey);
  } catch {
    return "none";
  }
  switch (value) {
    case "authentication":
    case "session":
    case "user":
      return value;
    case "business-list":
    case "business":
      return "session";
    default:
      return "none";
  }
};

export const setSessionTestFailure = (failure: SessionTestFailure) => {
  if (!sessionTestControlsEnabled) return;
  if (failure === "none") sessionStorage.removeItem(storageKey);
  else sessionStorage.setItem(storageKey, failure);
};

export class SimulatedSessionFailure extends Error {
  constructor(public readonly stage: SessionInitializationStage) {
    super(`Simulated session failure: ${stage}`);
  }
}

export const simulateSessionFailure = (stage: SessionInitializationStage) => {
  if (sessionTestControlsEnabled && getSessionTestFailure() === stage) {
    throw new SimulatedSessionFailure(stage);
  }
};

export const simulateSessionRequestFailure = (path: string, method: string) => {
  if (!sessionTestControlsEnabled) return;
  if (method.toLowerCase() === "post" && path === "auth/session") {
    simulateSessionFailure("session");
  } else if (method.toLowerCase() === "post" && path === "users") {
    simulateSessionFailure("user");
  } else if (method.toLowerCase() === "get") {
    if (path === "businesses") simulateSessionFailure("business-list");
    else if (/^businesses\/\d+$/.test(path)) simulateSessionFailure("business");
  }
};
